module.exports = __webpack_public_path__ + "img/1.37ebaf21.png";